import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { animated, useSpring } from "react-spring";
import styled from "styled-components";
import { GATSBY_URL } from "../config";
import LogOutButton from "./LogOutButton";

const StyledHeader = styled.header`
  width: 100%;
  height: 75px;
  position: relative;
  box-shadow: ${(props) =>
    props.noShadow ? "none" : "0 3px 45px rgba(0, 0, 0, 0.15)"};
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    justify-content: left;
    .logo {
      margin-left: 15px;
    }
  }
  .logo {
    display: flex;
    align-items: center;
    font-size: 2rem;
    height: 45px;
    a {
      text-decoration: none;
      color: black;
      height: 100%;
    }
    img {
      height: 100%;
      margin-right: 5px;
    }
    @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
      .neoh {
        display: none;
      }
    }
  }
  .buttonWrapper {
    position: absolute;
    top: 5px;
    right: 5px;
  }
`;

const Header = ({ userLoading, userData, refetchUser, location }) => {
  // Hide box-shadow when on course page
  const currentPathname = location.pathname;
  // eslint-disable-next-line
  const match = currentPathname.match(/(\/course\/[^\/]+)/g);
  const noShadow = match
    ? match[0] === currentPathname
      ? true
      : false
    : false;

  return (
    <StyledHeader noShadow={noShadow}>
      <div className="logo">
        <a href={`${GATSBY_URL}/`}>
          <img src="/adam_logo.png" alt="" />
        </a>

        <a href={`${GATSBY_URL}/`} className="neoh">
          The New Era of Health
        </a>
      </div>
      <AccountButton
        userLoading={userLoading}
        userData={userData}
        refetchUser={refetchUser}
      />
    </StyledHeader>
  );
};

export default withRouter(Header);

const StyledAccountButton = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 1000;

  button.userIcon {
    position: absolute;
    padding: 0;
    top: 0;
    right: 0;
    border-radius: 100%;
    background: ${(props) => props.theme.primaryBlue};
    width: 45px;
    height: 45px;
    color: white;
    font-size: 25px;
    z-index: 1;
  }
  .accountOptions {
    opacity: ${(props) => (props.showOptions ? 1 : 0)};
    pointer-events: ${(props) => (props.showOptions ? "auto" : "none")};
    transition: opacity 250ms ease-out;
    position: absolute;
    top: 60px;
    right: 0;
    background: white;
    padding: 15px;
    box-shadow: ${(props) => props.theme.boxShadow};
    font-family: "Roboto", sans-serif;
    width: 150px;
    z-index: 1;
    .course,
    .account,
    .mainSite {
      padding-bottom: 15px;
    }
  }
  .overlay {
    display: ${(props) => (props.showOptions ? "block" : "none")};
    position: absolute;
    width: 100vw;
    height: 100vh;
    top: -15px;
    right: -15px;
    z-index: 0;
  }
`;

const AccountButton = (props) => {
  const [showOptions, setshowOptions] = useState(false);
  const [buttonSpringProps, set] = useSpring(() => ({
    config: { mass: 2, friction: 20, tension: 400 },
  }));

  const closeOptions = () => {
    setshowOptions(false);
  };
  return (
    <StyledAccountButton showOptions={showOptions}>
      <animated.button
        className="userIcon"
        onMouseEnter={() => set({ transform: "scale(1.1)" })}
        onMouseLeave={() => set({ transform: "scale(1)" })}
        style={buttonSpringProps}
        onClick={() => {
          setshowOptions(!showOptions);
        }}
      >
        <FontAwesomeIcon icon={faUser} />
      </animated.button>
      <div className="accountOptions">
        <div className="course">
          <Link to="/" onClick={() => closeOptions()}>
            My courses
          </Link>
        </div>
        <div className="mainSite">
          <a href={`${GATSBY_URL}/`}>Main website</a>
        </div>
        <div className="account">
          <Link to="/account" onClick={() => closeOptions()}>
            My account
          </Link>
        </div>

        <div className="login">
          {props.userLoading ? (
            "Loading"
          ) : props.userData ? (
            <LogOutButton
              closeOptions={() => closeOptions()}
              refetchUser={props.refetchUser}
            />
          ) : (
            <Link to="/login" onClick={() => closeOptions()}>
              Log in
            </Link>
          )}
        </div>
      </div>
      <div className="overlay" onClick={() => closeOptions()}></div>
    </StyledAccountButton>
  );
};
